import React from 'react';
import { useDataSyncTranslations } from 'modules/dataSync/hooks/useDataSyncTranslations';
import { BaseCellWrapper } from './BaseCell';
import { TextWrapper } from './LastSync.styles';
import { Tooltip } from 'ui/tooltip';
import { localizeDateTime, localizeRelativeTimeSince, DateFormat, TimeFormat } from 'utils/l10n';

interface LastSyncCellProps {
  lastSync?: string | null;
}

export const LastSyncCell: React.FC<LastSyncCellProps> = React.memo(({ lastSync }) => {
  const { t } = useDataSyncTranslations();

  const syncTime = lastSync ? localizeRelativeTimeSince(new Date(lastSync)) : null;
  const fullDateTime = lastSync
    ? localizeDateTime(new Date(lastSync), {
        dateStyle: DateFormat.Numeric,
        timeStyle: TimeFormat.TwelveHour,
        showTime: true,
      })
    : null;

  return (
    <BaseCellWrapper dataTestId="last-sync-cell">
      {syncTime ? (
        <Tooltip isUnderlined tooltipContent={fullDateTime} isEnabled={!!fullDateTime}>
          <TextWrapper>{syncTime}</TextWrapper>
        </Tooltip>
      ) : (
        <span aria-label="No sync information available">{t('common.na')}</span>
      )}
    </BaseCellWrapper>
  );
});
